<template>
  <v-layout row wrap align-center>
    
    <v-flex xs12 sm4 md3>
      <v-select
        v-model="selectedCountry"
        :items="filteredCountries"
        item-text="name"
        return-object
        dense
        outlined
        hide-details
        :clearable="false"
        :disabled="disabled"
        :menu-props="{ maxHeight: 380 }"
        :no-data-text="'Ülke bulunamadı'"
      >
       
        <template v-slot:prepend-item>
          <v-list-tile>
            <v-text-field
              v-model="countrySearch"
              placeholder="Ülke / Kod ara (TR, Turkey, +90...)"
              dense
              hide-details
              solo
              flat
              clearable
              @click.stop
              @keydown.stop
            />
          </v-list-tile>
          <v-divider />
        </template>

        <template v-slot:selection="{ item }">
          <span style="display:flex; align-items:center; gap:8px;">
            <span
              :class="flagClass(item.iso2)"
              style="width:20px; height:14px; display:inline-block;"
            ></span>
            <span>{{ item.dialCode }}</span>
          </span>
        </template>

        <template v-slot:item="{ item }">
          <span style="display:flex; align-items:center; gap:10px;">
            <span
              :class="flagClass(item.iso2)"
              style="width:20px; height:14px; display:inline-block;"
            ></span>
            <span style="min-width:58px;">{{ item.dialCode }}</span>
            <span>{{ item.name }}</span>
          </span>
        </template>
      </v-select>
    </v-flex>

    <!-- TELEFON -->
    <v-flex xs12 sm8 md9>
      <v-text-field
        v-model="displayPhone"
        :label="label"
        :rules="rules"
        outlined
        dense
        hide-details="auto"
        type="tel"
        :placeholder="placeholder"
        :disabled="disabled"
        @input="onDisplayInput"
        @blur="onBlur"
      />
    </v-flex>
  </v-layout>
</template>

<script>
import metadata from "libphonenumber-js/metadata.min.json";
import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js";

export default {
  name: "PhoneInput",
  props: {
    value: { type: String, default: "" }, // API format: +905334413747
    label: { type: String, default: "Telefon" },
    locale: { type: String, default: "tr-TR" },

   
    rules: { type: Array, default: function () { return []; } },
    disabled: { type: Boolean, default: false }
  },
  data: function () {
    return {
      countries: [],
      selectedCountry: null,
      displayPhone: "",
      countrySearch: "",

     
      lastE164: ""
    };
  },
  computed: {
    placeholder: function () {
      return this.selectedCountry && this.selectedCountry.iso2 === "TR"
        ? "(5xx) xxx-xxxx"
        : "";
    },
    filteredCountries: function () {
      var q = (this.countrySearch || "").toLowerCase().trim();
      if (!q) return this.countries;

      return this.countries.filter(function (c) {
        var name = (c.name || "").toLowerCase();
        var iso2 = (c.iso2 || "").toLowerCase();
        var dial = (c.dialCode || "").toLowerCase();
        return name.indexOf(q) > -1 || iso2.indexOf(q) > -1 || dial.indexOf(q) > -1;
      });
    }
  },
  created: function () {
    this.countries = this.buildCountriesFromLibPhone();

    // default TR
    this.selectedCountry = this.findCountryByIso2("TR") || this.countries[0];

    
    this.setFromE164(this.value);
  },
  watch: {
   
    value: function (newVal) {
      this.setFromE164(newVal);
    },
    
    selectedCountry: function () {
      this.onDisplayInput(this.displayPhone);
    }
  },
  methods: {
    
    buildCountriesFromLibPhone: function () {
      var dn =
        typeof Intl !== "undefined" && Intl.DisplayNames
          ? new Intl.DisplayNames([this.locale], { type: "region" })
          : null;

      
      var ccc = metadata.country_calling_codes || {};

      
      var iso2ToDial = {};
      Object.keys(ccc).forEach(function (dialDigits) {
        var arr = ccc[dialDigits] || [];
        for (var i = 0; i < arr.length; i++) {
          var iso2 = String(arr[i] || "").toUpperCase();
          if (iso2) iso2ToDial[iso2] = dialDigits;
        }
      });

      
      var iso2List = Object.keys(metadata.countries || {}).sort();

      var list = [];
      for (var j = 0; j < iso2List.length; j++) {
        var iso2 = iso2List[j];
        var dial = iso2ToDial[iso2]; 
        if (!dial) continue;

        var name = dn ? dn.of(iso2) : iso2;

        list.push({
          iso2: iso2,
          name: name,
          dialCode: "+" + dial
        });
      }

      // Türkiye en başa, diğerleri alfabetik
      var turkey = null;
      var others = [];
      for (var k = 0; k < list.length; k++) {
        if (list[k].iso2 === "TR") turkey = list[k];
        else others.push(list[k]);
      }

      others.sort(function (a, b) {
        return (a.name || "").localeCompare(b.name || "");
      });

      return turkey ? [turkey].concat(others) : others;
    },

    findCountryByIso2: function (iso2) {
      var up = String(iso2 || "").toUpperCase();
      for (var i = 0; i < this.countries.length; i++) {
        if (this.countries[i].iso2 === up) return this.countries[i];
      }
      return null;
    },

    flagClass: function (iso2) {
     
      return ["flag-icon", "flag-icon-" + String(iso2 || "").toLowerCase()];
    },

    digitsOnly: function (s) {
      return String(s || "").replace(/\D/g, "");
    },

   
    onDisplayInput: function (val) {
      var iso2 =
        this.selectedCountry && this.selectedCountry.iso2
          ? this.selectedCountry.iso2
          : "TR";

      var ayt = new AsYouType(iso2);
      var formatted = ayt.input(val || "");
      this.displayPhone = formatted;

      var nationalDigits = this.digitsOnly(this.displayPhone);

     
      var dialCode =
        this.selectedCountry && this.selectedCountry.dialCode
          ? this.selectedCountry.dialCode
          : "+90";

      var candidate = dialCode + nationalDigits;

      var parsed = parsePhoneNumberFromString(candidate, iso2);
      if (parsed && parsed.isValid()) {
        this.lastE164 = parsed.number;
        this.$emit("input", parsed.number); // v-model
      } else {
        this.lastE164 = "";
        this.$emit("input", ""); // v-model invalid ise boş
      }
    },

   
    onBlur: function () {
      this.normalizeIfPossible();
      this.$emit("change", this.lastE164);
    },

    normalizeIfPossible: function () {
      var iso2 =
        this.selectedCountry && this.selectedCountry.iso2
          ? this.selectedCountry.iso2
          : "TR";

      var dialCode =
        this.selectedCountry && this.selectedCountry.dialCode
          ? this.selectedCountry.dialCode
          : "+90";

      var nationalDigits = this.digitsOnly(this.displayPhone);
      var candidate = dialCode + nationalDigits;

      var parsed = parsePhoneNumberFromString(candidate, iso2);
      if (parsed && parsed.isValid()) {
        this.displayPhone = parsed.formatNational();
        this.lastE164 = parsed.number;
        this.$emit("input", parsed.number);
      }
    },

    
    setFromE164: function (e164) {
      if (!e164) {
        this.displayPhone = "";
        this.lastE164 = "";
        return;
      }

      var parsed = parsePhoneNumberFromString(e164);
      if (!parsed) {
        this.displayPhone = "";
        this.lastE164 = "";
        return;
      }

      if (parsed.country) {
        var found = this.findCountryByIso2(parsed.country);
        if (found) this.selectedCountry = found;
      }

      this.displayPhone = parsed.formatNational();
      this.lastE164 = parsed.number;

      
      this.$emit("input", parsed.number);
    }
  }
};
</script>

<style scoped>

</style>
